/**
 * VisibilityToggle - Eye icon button for showing/hiding sensitive data
 */

import React from 'react';
import { IconButton } from '@chakra-ui/react';
import { ViewIcon, ViewOffIcon } from '@chakra-ui/icons';

interface VisibilityToggleProps {
  isVisible: boolean;
  onToggle: () => void;
  size?: 'xs' | 'sm' | 'md';
  ariaLabel?: string;
}

export const VisibilityToggle: React.FC<VisibilityToggleProps> = ({
  isVisible,
  onToggle,
  size = 'sm',
  ariaLabel = 'Toggle visibility'
}) => {
  return (
    <IconButton
      aria-label={ariaLabel}
      icon={isVisible ? <ViewIcon /> : <ViewOffIcon />}
      onClick={onToggle}
      size={size}
      variant="ghost"
      colorScheme="gray"
      _hover={{ bg: 'gray.100' }}
    />
  );
};

export default VisibilityToggle;
